var cccApp = cccApp || {};

(function (app) {
    "use strict";

    var apiHostUrl = "/webapi/v1/json/";

    // set global ajax settings
    $.ajaxSetup({
        jsonp: false,
        cache: false,
        timeout: 90 * 1000
    });
    
    app.api = (function() {

        var codes =
        {
            // 1xxx - informations
            INFO_Info: 1000,
            INFO_NoDataAvailable: 1001,
            INFO_ComputerOfflineAndNoDataAvailable: 1002,

            // 2xxx - success
            SUCC_Success: 2000,
            SUCC_TwilioRequested: 2500,
            SUCC_TwilioDisabling: 2501,
            SUCC_EmergencyCodeGenerated: 2502,
            SUCC_UpToDate: 2503,
            SUCC_NotUpToDate: 2504,

            // 3xxx - redirection & downloading
            REDIRECT_Redirection: 3000,
            REDIRECT_LoginSuccess: 3001,
            REDIRECT_TwoFactorAuthentication: 3002,
            REDIRECT_LinkedInstaller: 3003,
            REDIRECT_Downloading: 3100,

            // 4xxx warning code
            WARN_Warning: 4000,

            // 5xxx - errors
            ERR_Error: 5000,
            ERR_NotImplemented: 5001,
            ERR_UserValidationFailed: 5002,
            ERR_RegistrationFailed: 5003,
            ERR_NullArgument: 5004,
            ERR_UserAccessDenied: 5005,
            ERR_MaxComputersCountReached: 5006,
            ERR_ComputerNotExists: 5007,
            ERR_DataTooLong: 5008,
            ERR_IncorrectInputData: 5009,
            ERR_EntityDataNotFound: 5010,
            ERR_ZendeskError: 5011,
            ERR_ZendeskTopicNotExists: 5012,
            ERR_FeatureNotPurchased: 5013,
            ERR_UserValidationFailedRequestLimitExceeded: 5014,
            ERR_UserAccessDeniedTrayLogin: 5015,
            ERR_BroadcastFailure: 5020,
            ERR_TwilioCodeNotSet: 5101,
            ERR_TwilioCodeNotExists: 5102,
            ERR_TwilioCodeInvalid: 5103,
            ERR_TwilioCodeExpired: 5104,
            ERR_FeatureDisabled: 5105,
            ERR_HigherOsRequired: 5106,
            ERR_RequestLimitExceeded: 5107,
            ERR_EmptyDataSet: 5999,

            // 6xxx - Javascript Ajax Errors
            ERR_ResultExpected: 6000,
            ERR_RetriesExceeded: 6001,

            // -5000 - AJAX Error
            ERR_InternetConnection: -5000
        };

        var defaults = {
            type: "GET",
            url: "",
            data: undefined,
            retries: {
                tryCount: 0,
                retryLimit: 0,
                delay: 0,
                canRetry: undefined
            },
            global: true,
            action: "",
            messagePlaceholder: "global-messages",
            errorMessage: "Error occurred when requesting the action",
            resultExpected: true,
            detectNetwork: false,
            loading: undefined,
            success: function(result) {},
            error: function(error) {},
            complete: function() {},
            retriesExpired: undefined
        }

        function showMessage(e, placeholder, detailedInfo, url) {
            detailedInfo = typeof detailedInfo !== "undefined" ? detailedInfo : null;

            if (e.code < 2000) {
                cccApp.msg.info(e.message, placeholder, true, false);
            }
            else if (e.code < 3000) {
                cccApp.msg.success(e.message, placeholder, true, true);
            }
            else if (e.code < 4000) {
                if (e.code === app.api.codes.REDIRECT_LoginSuccess) {
                    loginRedirect(e.message, url);
                }
                else if (e.code === app.api.codes.REDIRECT_TwoFactorAuthentication) {
                    cccApp.msg.success(e.message, placeholder, true, false);
                }
                else {
                    if (cccApp.clientSystem.browser === "Internet Explorer") {
                        window.location.replace(e.message);
                    }
                    else {
                        $("body").append("<iframe src='" + window.location.origin + e.message + "' style='display: none;' ></iframe>");
                    }
                }
            }
            else if (e.code < codes.ERR_Error) {
                cccApp.msg.warning(e.message, placeholder, true, false);
            }
            else {
                cccApp.msg.error(e.message, placeholder, true, false);
            }
        }

        function codeCanShowAsGlobalError(errorCode) {
            switch (errorCode) {
                case codes.INFO_NoDataAvailable:
                case codes.INFO_ComputerOfflineAndNoDataAvailable:
                case codes.SUCC_Success:
                case codes.ERR_IncorrectInputData:
                case codes.ERR_FeatureDisabled:
                case codes.ERR_HigherOsRequired:
                case codes.ERR_RequestLimitExceeded:
                case codes.ERR_InternetConnection:
                    return false;
                default:
                    return true;
            }
        }

        function loginRedirect(defaultRedirectUrl, url) {
            var redirectUrl = cccApp.utils.getUrlParam("ReturnUrl");

            if (redirectUrl != null) {
                redirectUrl = decodeURIComponent(redirectUrl);
            } else if (url) {
                redirectUrl = url;
            } else {
                redirectUrl = defaultRedirectUrl;
            }

            window.location.replace(redirectUrl);
        }

        function retryAjax(ajaxRequest) {
            if (ajaxRequest.retries && ajaxRequest.retries.retryLimit > 0 
                && ajaxRequest.retries.tryCount < ajaxRequest.retries.retryLimit) {

                ajaxRequest.retries.tryCount++;
                //try again
                if (!ajaxRequest.retries.delay) {
                    $.ajax(ajaxRequest);
                }
                else if (typeof (ajaxRequest.retries.delay) === "number") {
                    setTimeout(function () { $.ajax(ajaxRequest); }, ajaxRequest.retries.delay);
                }
            }
        }

        var processAjaxResponse = function(xhr, config) {
            var resp = null;
            var responseType = xhr.getResponseHeader("content-type") || "";
            if (responseType.indexOf("html") > -1) {
                var errorMessage = (typeof config === "object" && config !== null && config.settings && config.settings.errorMessage) ? config.settings.errorMessage : "Error occurred when requesting the action";
                resp = { error: { code: xhr.statusCode + 6000, message: errorMessage } }
            } else if (typeof xhr.responseText !== "undefined") {
                resp = $.parseJSON(xhr.responseText);
            }

            if (resp == null) return;
            if (resp.error == null) return;
            if (resp.error.message == null) return;

            var e = resp.error;

            // set placeholder for message
            var placeholder = "global-messages";
            if (typeof config === "object" && config !== null && config.settings && config.settings.messagePlaceholder != null) {
                placeholder = config.settings.messagePlaceholder;
            }

            // check for Access denied error (5005), so according to AGM-1560 redirect to login page
            if (e.code === codes.ERR_UserAccessDenied) {
                //don't redirect if already on login page. This protects against security errors when trying to login.
                if (window.location.pathname !== "/login" && window.location.pathname.substring(0, 6) !== "/login?") {
                    var retUrl = encodeURIComponent(window.location.pathname + window.location.hash);
                    window.location.replace("/login?ReturnUrl=" + retUrl); // %2fcomputers
                }
            }

            // check for redirect to events error (5107)
            if (e.code === codes.ERR_RequestLimitExceeded) {
                // redirect to events
                if (resp.error.message) {
                    var currentLocation = window.location.pathname + window.location.hash;

                    if (!resp.error.message.endsWith(currentLocation)) {
                        window.location.replace(resp.error.message);
                        $.featherlight.close();
                    }
                }
                return;
            }

            var url = null;
            if (typeof config === "object" && config != null && config.settings) {
                if (config.settings.url) {
                    url = config.url;
                }

                if (typeof (config.settings.loading) === "object") {
                    if (config.settings.loading.isInitializing() || config.settings.loading.hasExpired() || config.settings.loading.hasErrored()) {
                        return;
                    }
                }
            }

            // below are global message handlers
            // but few codes should be prevented from displaying in global error handlers, e.g. 1001 and 1002
            if (codeCanShowAsGlobalError(e.code) || (placeholder != null && placeholder !== "global-messages")) {
                showMessage(e, placeholder, null, url);
            }
        }

        var processAjaxError = function(jqxhr, config, errorThrown) {
            var resp;
            try {
                resp = $.parseJSON(jqxhr.responseText);
            } catch (ex) {
                resp = null;
            }
            var errorMessage = (typeof config === "object" && config !== null && config.settings && config.settings.errorMessage) ? config.settings.errorMessage : "Error occurred when requesting the action";

            if (resp != null && resp.error != null && resp.error.message != null) {
                errorMessage = resp.error.code + " - " + resp.error.message;
            } else if (errorThrown != null && errorThrown !== "") {
                errorMessage += " - " + errorThrown;
            } else {
                return;
            }

            var actionName = (typeof config !== "object" || config === null || !config.settings || !config.settings.action) ? "Unknown Error" : config.settings.action;

            var jsonEventData = {
                "error": errorMessage
            }

            if (actionName === "Unknown Error") {
                jsonEventData["url"] = (typeof config === "object" && config !== null) ? config.url : "Unknown Url";
            }

            if (config && config.retries && (config.retries.retryLimit === 0 || (config.retries.retryLimit > 0 && config.retries.tryCount > config.retries.retryLimit))) {
                processAjaxResponse(jqxhr, config);
            }
        }

        var runAjax = function(ajaxData) {

            if (typeof ajaxData !== "object" || ajaxData === null) {
                return;
            }

            if (typeof cccApp !== "undefined" && cccApp.connectivity) {
                if (!cccApp.connectivity.connected() && ajaxData.queueKey) {
                    cccApp.connectivity.queueRequest(ajaxData);
                    if (typeof ajaxData.connectionDropped === "function") {
                        ajaxData.connectionDropped();
                    }

                    if (ajaxData.global) {
                        cccApp.msg.networkFailure();
                    }
                    return;
                }

                if (cccApp.connectivity.appOffline()) {
                    return;
                }
            }

            var errorTag = "network-connection-failed";
            cccApp.msg.clearTagged("global-messages", errorTag, null);

            ajaxData.url = apiHostUrl + ajaxData.url;

            $.ajax({
                type: ajaxData.type,
                url: ajaxData.url,
                data: ajaxData.data,
                dataType: "json",
                global: ajaxData.global,
                settings: ajaxData.settings,
                retries: ajaxData.retries,
                success: function(result, textStatus, jqXhr) {

                    var response = $.parseJSON(jqXhr.responseText);
                    var loggingAction = (ajaxData.settings.action) ? ajaxData.settings.action : "Unknown Action";

                    if (typeof response === "undefined" || response === null) {
                        logError(loggingAction, false, {
                            error: "Null/Empty result received from API call",
                            url: this.url
                        });

                        if (ajaxData.settings.resultExpected) {
                            if (typeof ajaxData.error === "function") {
                                ajaxData.error({
                                    code: codes.ERR_ResultExpected,
                                    message: "Sorry, no data was received in response to your request"
                                });
                            } else {
                                cccApp.msg.error("Sorry, no data was received in response to your request");
                            }
                            return;
                        }
                    } else if (response.error) {

                        if (response.error.code >= codes.ERR_Error) {
                            logError(loggingAction, false, {
                                code: response.error.code || 0,
                                error: response.error.message || "Unknown Error",
                                url: this.url
                            });
                        }

                        if (response.error.code === codes.INFO_NoDataAvailable || response.error.code === app.api.codes.INFO_ComputerOfflineAndNoDataAvailable) {
                            if (typeof (ajaxData.settings.loading) === "object" && typeof (ajaxData.settings.loading.isInitializing) === "function") {
                                if (!ajaxData.settings.loading.hasExpired() && !ajaxData.settings.loading.isRefreshing()) {
                                    ajaxData.settings.loading.isInitializing(true);
                                    ajaxData.settings.loading.initializing(response.error.message);
                                }
                            }

                            if (response.data && typeof response.data === "object") {
                                // This is for refreshes where the error code indicates no data, but the response may contain a data property
                                // We want to process the success handler and allow for the next retry
                                // For example, Windows Updates returns error.code === 1001, but may also contain a data.refreshStatus
                                ajaxData.success(response);
                            }

                            if (this.retries && this.retries.retryLimit > 0 && this.retries.tryCount < this.retries.retryLimit) {
                                if (typeof this.retries.canRetry === "undefined") {
                                    retryAjax(this);
                                    return;
                                } else if (typeof this.retries.canRetry === "function") {
                                    if (this.retries.canRetry()) {
                                        retryAjax(this);
                                    }
                                    return;
                                }
                            } else {
                                if (ajaxData.settings.loading) {
                                    ajaxData.settings.loading.expired();
                                }
                                if (typeof ajaxData.retriesExpired === "function") {
                                    ajaxData.retriesExpired(response);
                                    return;
                                }
                            }
                        } else if (typeof (ajaxData.settings.loading) === "object" && typeof (ajaxData.settings.loading.isInitializing) === "function") {
                            ajaxData.settings.loading.isInitializing(false);
                        }
                    }

                    if (response && response.error && response.error.code >= codes.ERR_Error && typeof ajaxData.error === "function") {
                        ajaxData.error({
                            code: response.error.code,
                            message: response.error.message
                        });
                    } else if (typeof ajaxData.success === "function") {
                        if (typeof (ajaxData.settings.loading) === "object" && typeof (ajaxData.settings.loading.isInitializing) === "function") {
                            ajaxData.settings.loading.isInitializing(false);
                        }

                        ajaxData.success(response);
                    }
                },
                error: function(err, textStatus, errorThrown) {

                    var loggingAction = (ajaxData.settings.action) ? ajaxData.settings.action : "Unknown Action";

                    var resp;
                    try {
                        resp = (err.responseText ? $.parseJSON(err.responseText) : "N/P");
                    } catch (ex) {
                        resp = "N/P";
                    }

                    var errorString = "JQuery Handler Error: ";
                    if (typeof err !== "undefined" && err !== null) {
                        errorString += "Status: " + (err.status ? err.status : "N/P") + "|";
                        errorString += "Status Text: " + (err.statusText ? err.statusText : "N/P") + "|";
                        errorString += "Text Status: " + (textStatus ? textStatus : "N/P") + "|";
                        errorString += "Error Thrown: " + (errorThrown ? errorThrown : "N/P") + "|";
                        errorString += "Response Text " + resp;
                    } else {
                        errorString += "Unexpected error with no handler data provided";
                    }

                    logError(loggingAction, false, {
                        error: errorString,
                        url: this.url
                    });

                    if (this.retries && this.retries.retryLimit > 0 && this.retries.tryCount < this.retries.retryLimit) {
                        if (typeof this.retries.canRetry === "undefined") {
                            retryAjax(this);
                            return;
                        } else if (typeof this.retries.canRetry === "function") {
                            if (this.retries.canRetry()) {
                                retryAjax(this);
                            }
                            return;
                        }
                    }

                    var status = err && err.status ? err.status : -1;
                    if (typeof cccApp !== "undefined" && cccApp.connectivity && status === -1) {
                        cccApp.connectivity.connected(false);
                        cccApp.connectivity.queueRequest(ajaxData);
                        setTestConnectionTimeout(5 * 1000);
                        if (ajaxData.queueKey) {
                            if (typeof ajaxData.connectionDropped === "function") {
                                ajaxData.connectionDropped();
                            }

                            if (ajaxData.global) {
                                cccApp.msg.networkFailure();
                            }
                            return;
                        }
                    }

                    if (ajaxData.detectNetwork && typeof err !== "undefined" && err !== null) {
                        cccApp.msg.appOffline(status);
                        return;
                    }

                    err =
                    {
                        code: codes.ERR_InternetConnection,
                        message: "Sorry, there seems to a problem connecting to our services.  Please check your network connection",
                        status: err.status || "",
                        statusText: err.statusText || "",
                        textStatus: textStatus || "",
                        errorThrown: errorThrown
                    };

                    if (typeof ajaxData.error === "function") {
                        ajaxData.error(err);
                    }

                    if (typeof (ajaxData.settings.loading) === "object" && !ajaxData.settings.loading.hasErrored() && ajaxData.global) {

                        if (ajaxData.settings && ajaxData.settings.messagePlaceholder) {
                            cccApp.msg.error(err.message, ajaxData.settings.messagePlaceholder, true);
                        } else {
                            cccApp.msg.error(err.message, undefined, true);
                        }
                    }
                },
                complete: function() {
                    if (typeof ajaxData.complete === "function") {
                        ajaxData.complete();
                    }
                }
            });
        }

        var validateAjax = function (requestMethod, ajaxData) {

            if (typeof ajaxData !== "object" || ajaxData === null || !ajaxData.url || typeof requestMethod !== "string" || !requestMethod) {
                logError("Ajax called improperly", false,
                (typeof ajaxData === "undefined" || ajaxData === null) ?
                {
                    error: "Ajax is null or undefined",
                    requestMethod: requestMethod
                } :
                {
                    error: "Improper Ajax info supplied",
                    requestMethod: requestMethod,
                    ajaxData: json.stringify(ajaxData)
                });
                return false;
            }
            return true;
        };

        var ajaxRequest = function (requestMethod, ajaxData) {

            if (!validateAjax(requestMethod, ajaxData)) {
                return;
            }

            ajaxData.settings = {};
            if (ajaxData.action) {
                ajaxData.settings.action = ajaxData.action;
                ajaxData.action = undefined;
            }

            ajaxData.settings.messagePlaceholder = (ajaxData.messagePlaceholder) ? ajaxData.messagePlaceholder : defaults.messagePlaceholder;
            ajaxData.messagePlaceholder = undefined;

            ajaxData.settings.errorMessage = (ajaxData.errorMessage) ? ajaxData.errorMessage : defaults.errorMessage;
            ajaxData.errorMessage = undefined;

            ajaxData.settings.resultExpected = (ajaxData.resultExpected) ? ajaxData.resultExpected : defaults.resultExpected;
            ajaxData.resultExpected = undefined;

            ajaxData.settings.loading = (ajaxData.loading) ? ajaxData.loading : defaults.loading;
            ajaxData.loading = undefined;

            var ajaxObj = $.extend(true, {}, defaults, ajaxData);

            ajaxObj.type = requestMethod;

            runAjax(ajaxObj);
        };

        var ajaxGet = function (ajaxData) {
            ajaxRequest("GET", ajaxData);
        }

        var ajaxPost = function (ajaxData) {
            ajaxRequest("POST", ajaxData);
        };

        var ajaxPut = function (ajaxData) {
            ajaxRequest("PUT", ajaxData);
        };

        var ajaxDelete = function (ajaxData) {
            ajaxRequest("DELETE", ajaxData);
        };

        var testConnectionCounter = 0;
        var timeoutTestConnection = 0;

        function setTestConnectionTimeout(delay) {
            clearTimeout(timeoutTestConnection);
            timeoutTestConnection = setTimeout(testConnection, delay);
        }

        function testConnection() {
            clearTimeout(timeoutTestConnection);

            $.ajax({
                type: "GET",
                url: "/webapi/v1/json/service/status",
                success: function () {
                    if (cccApp.connectivity) {
                        cccApp.connectivity.connected(true);
                    }

                    cccApp.msg.clear("global-messages");
                    testConnectionCounter = 0;
                },
                error: function() {
                    cccApp.connectivity.connected(false);
                    testConnectionCounter = Math.min(testConnectionCounter++, 10);
                    setTestConnectionTimeout((10 + (testConnectionCounter * 5)) * 1000);
                }
            });
        }

        function processQueue(requestQueue) {
            if (!requestQueue) {
                return;
            }

            for (var key in requestQueue) {
                if (requestQueue.hasOwnProperty(key) && requestQueue[key] !== null) {
                    var ajaxData = requestQueue[key];
                    requestQueue[key] = null;
                    if (ajaxData.url) {
                        ajaxData.url = ajaxData.url.replace(apiHostUrl, "");
                    }

                    runAjax(ajaxData);
                }
            }
        }

        return {
            codes: codes,
            get: ajaxGet,
            put: ajaxPut,
            post: ajaxPost,
            'delete': ajaxDelete,
            processResponse: processAjaxResponse,
            processError: processAjaxError,
            processRequestQueue: processQueue
        };
    }());

}(cccApp));

$(document).ajaxError(function (e, jqxhr, settings, exception) {
    cccApp.api.processError(jqxhr, settings, exception);
});

$(document).ajaxSuccess(function (e, jqxhr, settings) {
    cccApp.api.processResponse(jqxhr, settings);
});